<div class="vi-root">

  <button class="vi-close" [mat-dialog-close]="" aria-label="Close">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
         stroke-width="1.8" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
  </button>

  <div class="vi-stage">
    <img [src]="data.img" id="map" alt="Enlarged photo"/>
  </div>

  <div class="vi-controls">
    <span class="vi-caption">{{ data.key }}</span>
    <div class="vi-zoom">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
           stroke-width="1.8" stroke="currentColor" class="vi-zoom-icon">
        <path stroke-linecap="round" stroke-linejoin="round"
              d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607ZM10.5 7.5v6m3-3h-6" />
      </svg>
      <input type="range" min="1" max="10" value="5" class="vi-slider" (change)="handleZoom($event)">
    </div>
  </div>

</div>

<style>
  .vi-root {
    position: relative;
    width: 100%;
    height: 100%;
    background: #1c1c1c;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .vi-close {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 10;
    width: 44px;
    height: 44px;
    border: none;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.18s ease;
  }
  .vi-close:hover { background: rgba(255, 255, 255, 0.25); }
  .vi-close svg { width: 24px; height: 24px; }

  .vi-stage {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: auto;
    padding: 40px 24px 16px;
  }
  .vi-stage img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    transform-origin: center center;
    border-radius: 8px;
  }

  .vi-controls {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    flex-wrap: wrap;
    padding: 16px 24px 22px;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.55), transparent);
  }
  .vi-caption {
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    font-family: 'Roboto', Arial, sans-serif;
  }
  .vi-zoom {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1 1 240px;
    max-width: 420px;
    justify-content: flex-end;
  }
  .vi-zoom-icon { width: 20px; height: 20px; color: #8cc63f; }
  .vi-slider {
    flex: 1 1 auto;
    max-width: 340px;
    height: 6px;
    border-radius: 50px;
    background: #4a4a4a;
    outline: none;
    appearance: none;
    -webkit-appearance: none;
  }
  .vi-slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #8cc63f;
    cursor: pointer;
  }
  .vi-slider::-moz-range-thumb {
    width: 18px;
    height: 18px;
    border: none;
    border-radius: 50%;
    background: #8cc63f;
    cursor: pointer;
  }
</style>
